import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons';
import { getColor } from '@panel/commons/core/themev3';
import closeButton from '../../../assets/icons/Cerrar.svg';
import ChevronDownGray from '../../../assets/icons/chevronDownGray.svg';
import ChevronDownBlack from '../../../assets/icons/chevronDownBlack.svg';

const ContainerLayout = styled.div`
  position: relative;
  width: ${({ isDesktop }) => (isDesktop ? '300px' : 'auto')};
  .search-container {
    margin: 32px 18px;
  }
  .btn-archive {
    font-size: 14px;
    display: flex;
    align-items: center;
    border: 1px solid ${selectColor('grayMediumLight')};
    width: 89%;
    margin: 16px;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 10px;
    cursor: pointer;
    justify-content: center;
    img {
      margin-right: 8px;
    }
    p {
      margin-top: 1px;
    }
    :hover {
      border-color: ${selectColor('black')};
    }
  }
`;

const ButtonWrapper = styled.div`
  padding: 16px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  left: 0px;
  background-color: ${selectColor('white')};
`;

const StyledButton = styled.button`
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${selectColor('white')}
  background-color: ${getColor('primary')};
  border-radius: 8px;
  padding: 0px 12px;
`;

const FilterPill = styled.div`
  background-color: ${selectColor('grayMediumLight')};
  display: flex;
  width: fit-content;
  padding: 9px;
  border-radius: 8px;
  margin: 0px 12px 12px 0px;
  > p {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    margin-left: 14px;
    cursor: pointer;
  }
`;

const PillsContainer = styled.div`
  max-width: ${({ isDesktop }) => isDesktop && '280px'};
  display: flex;
  flex-wrap: wrap;
`;

const ClearFilterButton = styled.div`
  color: ${getColor('primary')};
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-top: 12px;
  cursor: pointer;
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      position: absolute;
      top: 13px;
      right: 18px;
    `}
  img {
    width: 19px;
    height: 21px;
    margin-left: 6px;
  }
`;

const FiltersAppliedSection = styled.div`
  margin: ${({ isDesktop }) => (isDesktop ? '0px 18px' : '18px')};
`;

const FacetModuleContainer = styled.div`
  margin: 18px;
  border-bottom: 1px solid ${selectColor('grayMedium')};
  height: ${({ isExpanded }) => (isExpanded ? 'fit-content' : '38px')};
  overflow: hidden;
  cursor: pointer;
  .facet-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
    cursor: auto;
  }
  .see-more-less {
    font-weight: 600;
    color: ${({ active }) => selectColor(active ? 'black' : 'grayDark')};
    font-size: 16px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
  .seeMoreLess-icon {
    width: 14px;
    height: 9px;
    margin-left: 10px;
    background-image: url(${({ active }) => (active ? ChevronDownBlack : ChevronDownGray)});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    ${({ facetItemsLimited }) =>
      !facetItemsLimited &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

const FacetItem = styled.div`
  margin-bottom: 16px;
  font-size: 14px;
  cursor: pointer;
  white-space: break-spaces;
  font-weight: 400;
  color: ${selectColor('grayDarkLight')};
  line-height: 22.41px;
  :hover {
    color: ${selectColor('black')};
  }
`;

const Header = styled.div`
  background-color: ${({ isDesktop }) => (isDesktop ? 'none' : selectColor('blueDark'))};
  color: ${({ isDesktop }) => (isDesktop ? 'black' : 'white')};
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0px 18px;
  ${({ isDesktop }) =>
    !isDesktop
      ? css`
          justify-content: center;
        `
      : css`
          margin-top: 8px;
        `}
  position: relative;
  div {
    width: 60px;
    height: 58px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      width: 20px;
      height: 20px;
      background-image: url(${closeButton});
      background-repeat: no-repeat;
      background-position: cover;
    }
  }
  p {
    font-weight: 600;
    font-size: 20px;
    color: ${selectColor('grayDarkLight')};
  }
`;

export {
  ContainerLayout,
  FacetModuleContainer,
  FacetItem,
  Header,
  FiltersAppliedSection,
  FilterPill,
  ClearFilterButton,
  PillsContainer,
  ButtonWrapper,
  StyledButton
};
